// extracted by mini-css-extract-plugin
export default {"overview":"ProductMetrics_overview__b0Hmz","container":"ProductMetrics_container__y5a+o","custom_tabs":"ProductMetrics_custom_tabs__X0vif"};